// extracted by css-extract-rspack-plugin
export default {"iconContainer":"TjuEn","commandItemStack":"f7dtP"};